import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import { useState } from 'react'

import { i18WithParams as t } from '@shared/locale'
import { ButtonActions } from 'components-ui/src/button_actions/button_actions'
import { SimpleModal } from 'components-ui/src/simple_modal/simple_modal'
import { Spacer } from 'components-ui/src/spacer/spacer'
import { LocationClientDto, LocationPetProfileClientDto } from 'service-api/src/types/api'

interface TMemorializeDialogProps {
  lpp: LocationPetProfileClientDto
  location: LocationClientDto
  onClose: () => void
  onConfirm: (date: Date | null) => Promise<void>
}

export const MemorializeDialog = ({ lpp, location, onClose, onConfirm }: TMemorializeDialogProps) => {
  const [memoDate, setMemoDate] = useState<Date | null>(null)

  const onConfirmHandler = async () => onConfirm(memoDate)
  const onCloseHandler = async () => onClose()

  return (
    <SimpleModal open={true} onClose={onClose}>
      <div>
        <Typography variant="h6">{t('profile.pet.memorialize.title', { petName: lpp.displayName || '' })}</Typography>
        <Spacer height={3} />

        <Typography variant="body1">
          {t('profile.pet.memorialize.content', { locationName: location.displayName || '' })}
        </Typography>
        <Spacer height={3} />

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            value={memoDate}
            onChange={(date) => setMemoDate(date)}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  id="dob"
                  name="dob"
                  label={t('profile.pet.memorialize.date')}
                  variant="outlined"
                  sx={{ flex: 1 }}
                  fullWidth
                />
              )
            }}
          />
        </LocalizationProvider>
        <Spacer height={2} />

        <Stack direction="row" spacing={2}>
          <ButtonActions
            onAction={onConfirmHandler}
            onActionLabel={t('global.label.confirm')}
            onCancel={onCloseHandler}
            onCancelLabel={t('global.label.cancel')}
            invertButtons
          />
        </Stack>
      </div>
    </SimpleModal>
  )
}
